import {REDUCER_NAME as PARENT_REDUCER_NAME} from "../const";
import {REDUCER_NAME} from "./const";

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const SET_NEW_PHOTOS_NEEDED_REASON = NS + 'SET_NEW_PHOTOS_NEEDED_REASON'
export const SET_SELECTED_IMAGE_VERSIONS = NS + 'SET_SELECTED_IMAGE_VERSIONS';



// WEBPACK FOOTER //
// ./src/modules/customer/state/task-widget/type.js